module.exports = __webpack_public_path__ + "static/media/Grid.0e5dcf2d.svg";